import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { GenericLinkComponent } from '../generic-link/generic-link.component';
import { PhoneFilterPipe } from '@boels/helpers';

@Component({
  imports: [GenericLinkComponent, PhoneFilterPipe],
  selector: 'boels-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContactUsComponent {
  @Input()
  contactUsData?: {
    directHireIntro?: string;
    directHirePhoneNumber?: string;
    directHirePhoneSuffix?: string;
  };
}
